import { fetchFromBFF } from "./bffUtility";
import { ILogCreate, ILogDocument } from "../interfaces/interfaces";

export function saveLogUtility(logData: ILogCreate) {
    const endpoint = 'logger/add';

    fetchFromBFF(endpoint, {
        method: "POST",
        body: {
            level: logData.level,
            piletName: logData.piletName,
            user: logData.user,
            message: logData.message,
            details: logData.details,
            oldEntity: logData.oldEntity,
            newEntity: logData.newEntity,
            timestamp: new Date()
        }
    }).then(r => {

    }).catch(error => {
        console.error("Errore durante il salvataggio del log: ", error);
    });
}


export function searchLogUtility(piletName: string, level: string, searchTerm: string): Promise<ILogDocument> {
    const endpoint = 'logger/search';

    return fetchFromBFF(endpoint, {
        method: "POST",
        body: {
            piletName: piletName,
            level: level,
            searchTerm: searchTerm
        }
    }).then(r => {        
        return r as ILogDocument;
    }).catch(error => {
        console.error("Errore durante la ricerca del log: ", error);       
        throw error;
    });
}